export type AccessService = 'api' | 'sync';

export interface AccessProbeTarget {
  id: AccessService;
  label: string;
  url: string;
}

function asHttpUrl(rawUrl: string): string {
  const url = new URL(rawUrl);
  if (url.protocol === 'ws:') url.protocol = 'http:';
  if (url.protocol === 'wss:') url.protocol = 'https:';
  // Keep the configured route prefix. In production the Pages shell, API,
  // and sync worker share one hostname, so probing `/` can be satisfied by
  // the service-worker cache even when Cloudflare Access has expired for
  // `/api/*` or `/sync/*`.
  if (!url.pathname.endsWith('/')) url.pathname = `${url.pathname}/`;
  url.search = '';
  url.hash = '';
  return url.toString();
}

export function accessProbeTargets(apiUrl?: string, syncUrl?: string): AccessProbeTarget[] {
  return [
    ...(apiUrl ? [{ id: 'api' as const, label: 'API', url: asHttpUrl(apiUrl) }] : []),
    ...(syncUrl ? [{ id: 'sync' as const, label: 'Sync', url: asHttpUrl(syncUrl) }] : []),
  ];
}

export async function accessRouteRequiresSignIn(url: string): Promise<boolean | null> {
  try {
    const response = await fetch(url, {
      credentials: 'include',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    return response.status === 401;
  } catch {
    // Offline and DNS failures are connectivity problems, not proof that a
    // Cloudflare Access session expired. Preserve the previous state.
    return null;
  }
}
